module.exports = __webpack_public_path__ + "img/court-wood.07b2f110.jpg";